import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { NnnRegistrationPreviewComponent } from '../epd/careplan-nnn/components/nnn-registration-preview/nnn-registration-preview.component';
import { CasesRoutingModule } from './cases-routing.module';
import { CaseWorkgroupsComponent } from './components/case-workgroups/case-workgroups.component';
import { ChangePatientDialogComponent } from './components/change-patient-dialog/change-patient-dialog.component';
import { ConfirmChangingRatingSystemComponent } from './components/confirm-changing-rating-system/confirm-changing-rating-system.component';
import { ConfirmDeletingTasksDialogComponent } from './components/confirm-deleting-tasks-dialog/confirm-deleting-tasks-dialog.component';
import { ConfirmDeletingWorkgroupRegistrationDialogComponent } from './components/confirm-deleting-workgroup-registration-dialog/confirm-deleting-workgroup-registration-dialog.component';
import { CreateQuizInformationDialogComponent } from './components/create-quiz-information-dialog/create-quiz-information-dialog.component';
import { IframeDialogComponent } from './components/iframe-dialog/iframe-dialog.component';
import { SkeletonCasePatientComponent } from './components/skeleton-case-patient/skeleton-case-patient.component';
import { SkeletonCaseComponent } from './components/skeleton-case/skeleton-case.component';
import { SkeletonTasksComponent } from './components/skeleton-tasks/skeleton-tasks.component';
import { ConfirmNoRegistrationsDialogComponent } from './components/task/confirm-no-registrations-dialog/confirm-no-registrations-dialog.component';
import { TaskRegistrationDataComponent } from './components/task/task-registration-data/task-registration-data.component';
import { TaskSubmissionPanelComponent } from './components/task/task-submission-panel/task-submission-panel.component';
import { TaskStudentComponent } from './components/task/task-student/task-student.component';
import { TaskBulkRatingComponent } from './components/task/task-bulk-rating/task-bulk-rating.component';
import { TaskTeacherComponent } from './components/task/task-teacher/task-teacher.component';
import { TaskComponent } from './components/task/task.component';
import { CaseComponent } from './pages/case/case.component';
import { CasesComponent } from './pages/cases/cases.component';
import { EditCaseComponent } from './pages/edit-case/edit-case.component';

@NgModule({
  declarations: [
    CasesComponent,
    CaseComponent,
    EditCaseComponent,
    SkeletonCaseComponent,
    ConfirmNoRegistrationsDialogComponent,
    SkeletonTasksComponent,
    SkeletonCasePatientComponent,
    TaskComponent,
    TaskTeacherComponent,
    TaskBulkRatingComponent,
    TaskStudentComponent,
    TaskSubmissionPanelComponent,
    TaskRegistrationDataComponent,
    IframeDialogComponent,
    CaseWorkgroupsComponent,
    ChangePatientDialogComponent,
    ConfirmChangingRatingSystemComponent,
    ConfirmDeletingTasksDialogComponent,
    CreateQuizInformationDialogComponent,
    ConfirmDeletingWorkgroupRegistrationDialogComponent,
  ],
  imports: [SharedModule, CasesRoutingModule, NnnRegistrationPreviewComponent],
  exports: [CasesComponent, EditCaseComponent, CaseComponent],
})
export class CasesModule {}
